



















































































































































































































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { NotificacaoParmDTO, NOTIF_TARGET_CLIENT_UNITS, NOTIF_TARGET_PROFILES, NOTIF_TARGET_TEAMS, NOTIF_TARGET_USERS } from '@/interfaces/notification';
import * as service from '@/services/notification';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { EmailEditor } from 'vue-email-editor';
import { Prop, Watch } from 'vue-property-decorator';
import UiAutocompleClientsSubsidiaries from '../UI/autocomplete-clients-subsidiaries.vue';
import UiAutocompleTeams from '../UI/autocomplete-team.vue';
import UiDatePicker from '../UI/date-picker.vue';
import ListMessages from '../UI/list-messages.vue';
import WhatsappScheduleDialog from '../whatsapp/whatsapp-schedule-dialog.vue';
import NotificationDialog from './notification-dialog.vue';
import NotificationPrescriptionDialog from './notification-prescription-dialog.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiDatePicker,
    EmailEditor,
    NotificationDialog,
    NotificationPrescriptionDialog,
    UiAutocompleClientsSubsidiaries,
    UiAutocompleTeams,
    WhatsappScheduleDialog
  },
})
export default class NotificationForm extends BaseComponent {    
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: number;
  @Prop()
  public open: boolean;

  TARGET_USERS = NOTIF_TARGET_USERS;
  TARGET_PROFILES = NOTIF_TARGET_PROFILES;
  TARGET_CLIENT_UNITS = NOTIF_TARGET_CLIENT_UNITS;
  TARGET_TEAMS = NOTIF_TARGET_TEAMS;  

  target = this.TARGET_PROFILES;

  design = {};

  private loading: boolean = false;
  private error: boolean = false;

  public dto: NotificacaoParmDTO = new NotificacaoParmDTO();
  profiles = [];
  businessUnits = [];
  loadingLogins = false;
  logins = [];

  emailEditorOptions = {};
  emailEditorTools = {};

  showPreview = false;
  previewHtml = null;
  previewTitle = null;
  previewWidth = null;

  whatsappScheduleDialogFlag = false;

  public form: any = {
    valid: false,
    rules: {
      titulo: [(v) => !!v || 'Informe o Titulo'],
      ativo: [(v) => v != null || 'Informe o Status'],
      businessUnits: [(v) => (v != null && v.length > 0) || 'Escolha uma ou mais empresas'],
      profiles: [(v) => (v != null && v.length  > 0) || 'Escolha um ou mais perfis'],
      users: [(v) => (v != null && v.length  > 0) || 'Escolha um ou mais usuários'],
      clientUnits: [(v) => (v != null && v.length  > 0) || 'Escolha uma ou mais unidades'],
      teams: [(v) => (v != null && v.length  > 0) || 'Escolha um ou mais times'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };


  mounted() {
    setTimeout(() => {
      if (!this.dto.id && this.isEdit) {
        this.$refs['tituloField'].focus();
      }
    }, 500);

    this.registerLoadLoginsSubject();    
    this.loadBusinessUnits();
    this.loadProfiles();
    this.loadLogins();
  }

  @Watch('open', { immediate: true })
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        this.init();
      }
    }, 300);
  }

  private loadProfiles(): void {
    service.findNotificationProfiles().subscribe((data) => {
      this.profiles = data;
    });
  }

  public loadBusinessUnits() {
    service.findNotificationBusinessUnit().subscribe(
      (res) => {
        this.businessUnits = res;
      },
      (error) => {
        this.showToastApiError(error);
      },
    );
  }

  private loadLoginsSubject$: BehaviorSubject<any> = new BehaviorSubject(null);

  public registerLoadLoginsSubject() {
    this.loadLoginsSubject$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        switchMap((filter) => {
          this.loadingLogins = true;
          this.logins = [];
          return service.findNotificationLogins(filter.idsEmpresa);
        }),
      )
      .subscribe(
        (res) => {
          this.loadingLogins = false;
          this.logins = res;
          if (this.dto.idsLogin) {
            this.dto.idsLogin = this.dto.idsLogin.filter(id => this.logins.filter(l => l.id == id).length);
          }
        },
        (error) => {
          this.loadingLogins = false;
          this.showToastApiError(error);
        },
      );
  }

  public loadLogins() {
    this.loadLoginsSubject$.next(this.dto);
  }

  template = true;
  editable = true;
  type = 'GN';

  public init(): void {
    if (!this.id || this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.findNotificationById(this.id).subscribe(
        (result) => {
          this.dto = result;
          this.target = result.alvo;
          this.editable = result.tipo.editavel;
          this.template = result.tipo.template;
          this.type = result.tipo.id;
          if (this.editable) {
            this.loadLogins();
          } else {
            this.logins = result.logins;
          }
          this.dto.diaInicioPublicacao = this.dto.diaInicioPublicacao
            ? dateFormat(this.dto.diaInicioPublicacao, 'ISO', 'DD/MM/YYYY')
            : null;
          this.dto.diaFimPublicacao = this.dto.diaFimPublicacao
            ? dateFormat(this.dto.diaFimPublicacao, 'ISO', 'DD/MM/YYYY')
            : null;
          if (this.$refs['emailEditor']) {
            this.getEditor().loadDesign(JSON.parse(this.dto.templateJson));
          }
          this.loading = false;
        },
        (error) => {
          this.error = true;
          this.loading = false;
        },
      ),
    );
  }


  public saveItem(emailEditorData): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');
    this.dto.templateJson = JSON.stringify(emailEditorData.design);
    this.dto.conteudoHtml = emailEditorData.html;
    this.dto.larguraMaxTemplate = this.getEditorMaxWidth(emailEditorData);
    let parm = Object.assign(new NotificacaoParmDTO(), this.dto);
    parm.alvo = this.target;
    parm.diaInicioPublicacao = this.dto.diaInicioPublicacao ? dateFormat(this.dto.diaInicioPublicacao, 'BR') : null;
    parm.diaFimPublicacao = this.dto.diaFimPublicacao? dateFormat(this.dto.diaFimPublicacao, 'BR') : null;

    this.addSubsc(
      service.saveNotification(parm).subscribe(
        (result) => {
          this.resetForm();
          this.loader.stop();
          this.toast.show('Notificação salva com sucesso', 'success');
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        },
      ),
    );
  }

  getEditorMaxWidth(emailEditorData) {
    return Number(String(emailEditorData.design.body.values.contentWidth).replace(/[^0-9]/gi, ''));
  }

  public resetForm(): void {
    this.dto = new NotificacaoParmDTO();
    this.$refs.form.resetValidation();
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public closeForm(): void {
    if (!this.editable || !this.isEdit) {
      this.closeAction();
      return;
    }
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }

  editorLoaded() {
    let unlayer = this.getEditor();
    unlayer.registerCallback('image', this.uploadImage);

    if (this.dto && this.dto.templateJson) {
      unlayer.loadDesign(JSON.parse(this.dto.templateJson));
    }
  }

  uploadImage(file, done) {
    this.loader.start('Salvando imagem ...');
    service.uploadNotificationImage(file.attachments[0]).subscribe(
      (res) => {
        this.loader.stop();
        done({
          progress: 100,
          url: res.url,
        });
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
    );
  }

  editorReady() {
    document.querySelector('iframe').style.height = '700px';

    let unlayer = this.getEditor();
    unlayer.setBodyValues({
      contentWidth: '700px',
    });
  }
  prepareSave() {
    this.getEditor().exportHtml((data) => {
      this.saveItem(data);
    });
  }

  getEditor() {
    return this.$refs['emailEditor'].editor;
  }

  preview() {
    if (this.template) {
      this.getEditor().exportHtml((data) => {
        this.previewTitle = this.dto.titulo;
        this.previewWidth = this.getEditorMaxWidth(data);
        this.previewHtml = data.html;
        this.showPreview = true;
      });
    } else {
      this.showPreview = true;
    }
  }

  closePreview() {
    this.showPreview = false;
  }

  @Watch("target")
  onTargetChange() {
    setTimeout(() => {
      this.$refs.form.validate();      
    }, 500);
  }

  showWhatsappScheduleModal() {
    this.whatsappScheduleDialogFlag = true;
  }

  closeWhatsappScheduleModal() {
    this.whatsappScheduleDialogFlag = false;
  }
}
